import { z } from 'zod';
export const cubeConfigSchema = z.object({
    id: z.string().min(1, 'ID is required'),
    name: z.string().min(1, 'Name is required'),
    apiUrl: z.string().url('Valid API URL is required'),
});
//# sourceMappingURL=CubeApiConfig.js.map